'use strict'

var types = exports.types = require('./src/types')
exports.Type = require('./src/type')

exports.find = function findCardType (callback) {
  for (var typeName in types) {
    var type = types[typeName]
    var result = callback(type)
    if (result) return type
  }
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/creditcards-types/index.js
 ** module id = 356
 ** module chunks = 1
 **/